module.exports = __webpack_public_path__ + "img/share.8e3de2f3.png";